"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var use_translations_hook_1 = __importDefault(require("../../../context/translations/use-translations.hook"));
var installation_sketch_settings_component_1 = __importDefault(require("./installation-sketch-settings.component"));
var StartStopLevels = function (props) {
    var startLevel = props.startLevel, stopLevel = props.stopLevel, width = props.width, height = props.height, highestSetting = props.highestSetting, unit = props.unit;
    var getTranslation = use_translations_hook_1.default().getTranslation;
    var settings = [];
    if (startLevel) {
        settings.push({
            text: getTranslation('SKETCH:START_LEVEL'),
            value: startLevel,
            side: 'right',
            orientation: 'horizontal',
            testID: 'sketch-start-level',
        });
    }
    if (stopLevel) {
        settings.push({
            text: getTranslation('SKETCH:STOP_LEVEL'),
            value: stopLevel,
            side: 'right',
            orientation: 'horizontal',
            testID: 'sketch-stop-level',
        });
    }
    var sortedSettings = settings.sort(function (a, b) { return b.value - a.value; });
    return (react_1.default.createElement(react_1.default.Fragment, null, sortedSettings.length > 0 && (react_1.default.createElement(installation_sketch_settings_component_1.default, { settings: sortedSettings, height: height, width: width, highestSetting: highestSetting, unit: unit }))));
};
StartStopLevels.displayName = 'StartStopLevels';
exports.default = StartStopLevels;
//# sourceMappingURL=installation-start-stop-levels.component.js.map